import * as React from 'react';

import { ButtonType, ButtonWidget, InteractionState, TabStyles } from '@tableau/widgets';
import { CommonStyles } from '../../../common/react/CommonStyles';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { ExplorerDropdownStyles } from './ExplorerDropdownStyles';

const NAV = imgPath('show_nav_small.svg');
const NAV_ACTIVE = imgPath('show_nav_small_active.svg');
const NAV_DISABLED = imgPath('show_nav_small_disabled.svg');

export interface ExplorerDropdownButtonProps {
  readonly onClick: (e: React.SyntheticEvent<HTMLDivElement, Event>) => void;
  readonly testId: string;
  readonly renderButtonContent: (showingOrActive: boolean, disabled: boolean) => JSX.Element | string;
  readonly title?: string;
  readonly showingPanel?: boolean;
  readonly height?: string;
  readonly setButtonRef?: (element: ButtonWidget) => void;
  readonly buttonStyleOverrides?: React.CSSProperties;
  readonly disabled?: boolean;
  readonly renderButtonContentOnly?: boolean;
}

export function ExplorerDropdownButton(props: ExplorerDropdownButtonProps): JSX.Element  {
  // overriding focus style to better match existing vizportal focus styles
  const focusStyle = {
    borderColor: CommonStyles.Colors.FocusBorderBlue,
    borderBottomColor: 'black',
    boxShadow: '0 0 4px ' + TabStyles.Colors.Focus
  };

  return (
    <ButtonWidget buttonType={ButtonType.DarkText}
      handleClick={props.onClick}
      testId={props.testId}
      title={props.title}
      style={{...ExplorerDropdownStyles.ExplorerDropdownButtonGenericStyle, ...props.buttonStyleOverrides}}
      ref={props.setButtonRef}
      disabled={props.disabled}
      getContent={(interactionState: InteractionState) => {
        const showingOrActive = props.showingPanel || interactionState.hover || interactionState.active || interactionState.focus;
        const buttonStyle: React.CSSProperties = {
          height: props.height || 'auto',
          boxSizing: 'border-box',
          ...(props.disabled ? {backgroundColor: TabStyles.Colors.Transparent}: {}),
          ...(props.renderButtonContentOnly ? {borderBottomWidth: 0} : {}),
          ...(interactionState.focus ? focusStyle : {}),
        };
        const inactiveImg = props.disabled ? NAV_DISABLED : NAV;
        return (
          <div
            style={buttonStyle}
            className={ExplorerDropdownStyles.explorerDropdownButtonClass(showingOrActive, props.disabled)}
          >
            {props.renderButtonContent(showingOrActive, props.disabled)}
            {!props.renderButtonContentOnly &&
              <img
                src={showingOrActive ? NAV_ACTIVE : inactiveImg}
                className={ExplorerDropdownStyles.ExplorerDropdownArrowImg}
              />
            }
          </div>
        );
      }}
    />
  );
}
